export const CLAUDE_SONNET_4 = "anthropic/claude-sonnet-4";
export const GPT_4O = "openai/gpt-4o-2024-11-20";
export const TEXT_EMBEDDING_3_SMALL = "text-embedding-3-small";
export const PERPLEXITY_SONAR = "perplexity/sonar";
export const OPENROUTER_BASE_URL = "https://openrouter.ai/api/v1";